import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


// const initialState = {
//     data: [],
//     nextPage: null,
//     lastDoc: null,
//     loader: false,
//     error: "",
// };

export const fetchCompletedProjectList = createAsyncThunk(
    'completedProjects/fetchcompletedprojects',
    async ({ userUID, page, lim }) => {
        const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/projects/completedClients/${userUID}?page=${page}&limit=${lim}`);
        return response.data;
        
      }
    );
export const fetchAllCompletedProjectList = createAsyncThunk(
    'completedProjects/fetchallcompletedprojects',
    async ({ userUID}) => {
        const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/projects/allCompletedClients/${userUID}`);
        return response.data;
        
      }
    );

const completedReducer = createSlice({
    name: 'completedProjects',
   initialState: {
    data: { clients: [], currentPage: 1, hasNextPage: false },
    allCompletedData:{clients: []},
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompletedProjectList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCompletedProjectList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        console.log("redux data in", state.data);
      })
      .addCase(fetchCompletedProjectList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAllCompletedProjectList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllCompletedProjectList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.allCompletedData = action.payload;
        console.log("redux data in", state.data);
      })
      .addCase(fetchAllCompletedProjectList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default completedReducer.reducer;